import { t } from '@glory/i18n';
import { ContentSwap, PageHeader, SkeletonRows } from '@glory/ui';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { AwaitingClientToday } from '../../features/documents/ui/awaiting-client-today.tsx';
import { AwaitingSignatureToday } from '../../features/documents/ui/awaiting-today.tsx';
import { EdoToday } from '../../features/edo/ui/edo-today.tsx';
import { EstimatesToday } from '../../features/estimates/ui/estimates-today.tsx';
import { FinanceToday } from '../../features/finance/ui/finance-today.tsx';
import { ProjectsToday } from '../../features/projects/ui/projects-today.tsx';
import { InboxStrip } from '../../features/today/inbox-strip.tsx';
import { NotificationsCard } from '../../features/today/notifications-card.tsx';
import { ContractStepToday } from '../../features/team/contract-step.tsx';
import { SalesToday } from '../../features/today/sales-today.tsx';
import { SetupChecklist } from '../../features/today/setup-checklist.tsx';
import { orpc } from '../../lib/orpc.ts';
import { usePermissions } from '../../lib/permissions.ts';
import { meQuery } from '../../lib/session.ts';

export const Route = createFileRoute('/_app/today')({
  component: TodayPage,
});

function greeting(name: string, hour: number): string {
  const first = name.split(' ')[0] ?? name;
  if (hour >= 5 && hour < 12) return t('today.greetingMorning', { name: first });
  if (hour >= 12 && hour < 18) return t('today.greetingDay', { name: first });
  if (hour >= 18 && hour < 23) return t('today.greetingEvening', { name: first });
  return t('today.greetingNight', { name: first });
}

function TodayPage() {
  const { data: me } = useSuspenseQuery(meQuery);
  const { can } = usePermissions();
  // Шаги выполняются на других экранах — при возвращении сюда перечитываем.
  const setup = useQuery({ ...orpc.today.setup.queryOptions(), staleTime: 0 });
  return (
    <div className="flex flex-col gap-4 px-4 py-5 md:px-6">
      <PageHeader title={greeting(me.name, new Date().getHours())} />
      {/* Входящее одной строкой, затем рабочее на сегодня; запуск студии и уведомления — под ним. */}
      <InboxStrip />
      <ContractStepToday />
      <AwaitingSignatureToday />
      {can('projects.use') ? <ProjectsToday /> : null}
      {can('sales.use') ? <AwaitingClientToday /> : null}
      {can('sales.use') ? <SalesToday /> : null}
      {can('sales.use') ? <EstimatesToday /> : null}
      {can('finance.read') || can('finance.invoices') ? <FinanceToday full={can('finance.read')} /> : null}
      {can('documents.templates') ? <EdoToday /> : null}
      <ContentSwap
        swapKey={setup.isPending ? 'loading' : setup.isError ? 'error' : setup.data ? 'setup' : 'feed'}
      >
        {setup.isPending ? (
          <SkeletonRows rows={3} />
        ) : setup.isError ? null : setup.data ? (
          <SetupChecklist steps={setup.data.steps} />
        ) : (
          <NotificationsCard />
        )}
      </ContentSwap>
    </div>
  );
}
